import { render, staticRenderFns } from "./Watchlist.vue?vue&type=template&id=64841c52&scoped=true&"
import script from "./Watchlist.vue?vue&type=script&lang=js&"
export * from "./Watchlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64841c52",
  null
  
)

export default component.exports